var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"b-button _icon _fa",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteNodes({id: _vm.id})}}},[_c('font-awesome-icon',{attrs:{"icon":"trash-alt","fixed-width":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }